import { z } from 'zod'

export const AGENTMCP_CATALOG_READ_CONTRACT_VERSION = '1.0.0' as const

export const agentmcpCatalogListResponseSchema = z.object({
  manifests: z.array(z.record(z.unknown())),
  generated_at: z.string(),
}).passthrough()

export type AgentmcpCatalogListResponse = z.infer<typeof agentmcpCatalogListResponseSchema>
